const Permission = {
    permission : () => `admin/permission`,
    removePermission : () => `admin/remove-permission`,
    grantPermission : () => `admin/grant-permission`,
    structuredPermission : () => `admin/structured-permissions`,
    permissionById : (id:string) => `admin/permission/${id}`,
}
export default Permission